<template>
  <create-dialog
    width="80%"
    :title="title"
    @closeModal="$emit('closeModal', false)"
    @validate="validateForm"
    ref="createDialog"
  >
    <template slot="form">
      <div class="row">
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4`">
          <fg-input
            :label="`${$t('common_words.code')}:`"
            ref="code"
            type="text"
            v-model="model.code"
            :placeholder="`${$t('common_words.code')}`"
          >
          </fg-input>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4`">
          <fg-input
            :label="`${$t('inventory.article')}: *`"
            ref="name"
            type="text"
            v-model="model.name"
            v-validate="modelValidations.name"
            name="inventory.article"
            :error="getError('inventory.article', true)"
            :placeholder="`${$t('inventory.article')}`"
          >
          </fg-input>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-4`">
          <div class="form-group has-label">
            <label>{{ $t('labor.unit') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select mb-3 shadow-sm required-supplying_unit"
              v-model="model.supplying_unit_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="option in supplyingUnits"
                :label="option.name"
                :value="option.id"
                :key="option.id + option.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-3 col-xl-3`">
          <div class="form-group has-label">
            <label>{{ $t('inventory.toxicity_classification') }}:</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select mb-3 shadow-sm"
              v-model="model.toxicity_classification_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="option in toxicityClassifications"
                :label="option.name"
                :value="option.id"
                :key="option.id + option.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-4 col-xl-3`">
          <div class="form-group has-label">
            <label>{{ $t('inventory.article_category') }}: *</label>
            <br />
            <el-select
              clearable
              filterable
              class="select-primary custom-width-select mb-3 shadow-sm required-article_category"
              v-model="model.article_category_id"
              :placeholder="`${$t('common_words.select')}...`"
            >
              <el-option
                class="select-primary"
                v-for="option in articleCategories"
                :label="option.name"
                :value="option.id"
                :key="option.id + option.name"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div :class="`col-12 col-sm-6 col-md-6 col-lg-5 col-xl-6`">
          <fg-input
            :label="`${$t('common_words.description')}: `"
            ref="description"
            type="text"
            v-model="model.description"
            :placeholder="`${$t('common_words.description')}`"
          >
          </fg-input>
        </div>
        <div :class="`col-12`">
          <select-businesses-component
            ref="selectBusiness"
            :showLoading="true"
            :requiered="true"
            :initialData="businessesInitial"
            @onChange="updateSelectedBusinesses"
            @showHideLoading="showHideLoading"
          />
        </div>
      </div>
    </template>
  </create-dialog>
</template>
<script>
import { Axios } from 'src/class/Axios.js';
import { isset } from 'src/util/Util';
import MixinDialog from 'src/mixins/mixin-dialog';
import MixinForm from 'src/mixins/forms/mixin-form';
import MixinLoading from 'src/mixins/mixin-loading';
import MixinPermissions from 'src/util/mixinPermissions';
import MixinValidations from 'src/mixins/forms/mixin-validations';

export default {
  name: 'edit-or-create',
  props: {
    syncDialog: {
      type: Object,
      default: () => {
        return { create: false, disabledField: false };
      },
    },
  },
  watch: {
    syncDialog(newValue) {
      if (newValue.create) this.openModal('create', newValue.disabledField);
      else this.closeModal('create', newValue.disabledField);
    },
  },
  mixins: [
    MixinDialog,
    MixinForm,
    MixinPermissions,
    MixinLoading,
    MixinValidations,
  ],
  data() {
    return {
      disabledField: false,
      businessesInitial: [],
      articleCategories: [],
      supplyingUnits: [],
      toxicityClassifications: [],
      model: {
        name: null,
        code: null,
        supplying_unit_id: null,
        article_category_id: null,
        toxicity_classification_id: null,
        description: null,
        businesses_id: [],
        businesses_names: [],
      },
      modelValidations: {
        name: { required: true },
      },
    };
  },
  methods: {
    validateForm() {
      this.$validator.validateAll().then((isValid) => {
        if (isValid) {
          if (!isset(this.model.supplying_unit_id))
            return this.validationInputsRequired('supplying_unit');
          else if (!isset(this.model.article_category_id))
            return this.validationInputsRequired('article_category');
          if (!isset(this.model.businesses_id)) {
            return this.validationInputsRequired('bus-rels');
          } else {
            this.$emit('addEdit', this.model);
          }
        }
      });
    },
    updateSelectedBusinesses(data) {
      const bsSelected = data.associations_ids.concat(data.businesses_ids);
      this.$set(this.model, 'businesses_id', bsSelected);
      this.$set(this.model, 'businesses_names', data.names);
    },
  },
  mounted() {
    if (this.isCreate() || this.isUpdate()) {
      Promise.all([
        Axios.getMasters('inventory/articlecategory'),
        Axios.getMasters('inventory/supplyingunit'),
        Axios.getMasters('inventory/toxicityclassification'),
      ])
        .then(
          ([
            responseArticleCategory,
            responseSupplyingUnit,
            responseToxicityClassification,
          ]) => {
            this.articleCategories = responseArticleCategory.data.data;
            this.supplyingUnits = responseSupplyingUnit.data.data;
            this.toxicityClassifications =
              responseToxicityClassification.data.data;
          }
        )
        .catch((error) => this.showMessageErrors(error));
    }
  },
  updated() {
    if (sessionStorage.getItem('editForm') && this.isUpdate()) {
      const editForm = JSON.parse(sessionStorage.getItem('editForm'));
      const {
        id,
        code,
        name,
        article_category_id,
        supplying_unit_id,
        toxicity_classification_id,
        description,
      } = JSON.parse(sessionStorage.getItem('editForm'));
      this.model = {
        ...this.model,
        id,
        code,
        name,
        article_category_id,
        supplying_unit_id,
        toxicity_classification_id,
        description,
        isEdit: true,
      };
      const { business, businesses } = editForm;
      this.$set(this, 'businessesInitial', businesses ? businesses : business);
      sessionStorage.removeItem('editForm');
    }
  },
};
</script>
